import apiClient from './api';

const orderService = {
    getMyOrders: async () => {
        const response = await apiClient.get('/orders/my-orders');
        return response.data;
    }
};

export default orderService;
